import lozad from 'lozad';
import domReady from '../utils/domReady';


const lazyImages = () => {
  domReady(() => {
    // Lazy Load Images
    const imgObserver = lozad('.u-lazy', {
      loaded(el) {
        // Custom implementation on a loaded element
        el.classList.add('is-loaded');
      },
    });
    imgObserver.observe();

    if (typeof FWP !== 'undefined') {
      // eslint-disable-next-line no-undef
      jQuery(document).on('facetwp-loaded afterAjaxSuccess.tribeEvents', () =>
        imgObserver.observe(),
      );
    }
  })
}

lazyImages();
